import styled from 'styled-components';

export const DateTimePickerWrapper = styled.div`
    flex: 1;
    width: 100%;
    
    > div {
        width: 100%;
        
        input[type="text"] {
            height: 32px !important;
            padding: 6px 12px !important;
            font-size: 14px !important;
            border-radius: 6px !important;
            border: 1px solid ${(props: any) => props.theme.colors.interfaceText100} !important;
            background: ${(props: any) => props.theme.colors.white} !important;
            color: ${(props: any) => props.theme.colors.interfaceText500} !important;
            transition: border-color 0.2s !important;
            font-weight: 400 !important;
            line-height: 24px !important;
            font-family: inherit !important;
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.c000000} !important;
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.c000000} !important;
                outline: none !important;
                box-shadow: none !important;
            }
        }
    }
    
    &.error {
        input[type="text"] {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400} !important;
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400} !important;
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400} !important;
            }
        }
    }
`;

export const Container = styled.div`
    width: 100%;
`;

